<template>
  <main class="mobile-unavailable" aria-labelledby="mobile-unavailable-message">
    <div class="ambient ambient-top" aria-hidden="true"></div>
    <div class="ambient ambient-bottom" aria-hidden="true"></div>

    <header class="brand">
      <img src="@/assets/pc/logo.png" alt="Viwoods">
    </header>

    <section class="message-panel">
      <div class="device-illustration" aria-hidden="true">
        <svg viewBox="0 0 300 230" role="presentation">
          <defs>
            <linearGradient id="screen-surface" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stop-color="#fbfcf8"/>
              <stop offset="1" stop-color="#e4eade"/>
            </linearGradient>
            <linearGradient id="phone-surface" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stop-color="#ffffff"/>
              <stop offset="1" stop-color="#edf1e9"/>
            </linearGradient>
            <filter id="device-shadow" x="-30%" y="-30%" width="160%" height="180%">
              <feDropShadow dx="0" dy="10" stdDeviation="12" flood-color="#173c2d" flood-opacity=".13"/>
            </filter>
          </defs>

          <path class="orbit orbit-back" d="M43 132c18-57 67-91 125-88 43 2 78 24 96 59"/>
          <path class="orbit orbit-front" d="M37 151c28 37 70 57 117 55 42-2 80-22 105-54"/>
          <circle class="orbit-dot orbit-dot-left" cx="40" cy="140" r="5"/>
          <circle class="orbit-dot orbit-dot-right" cx="260" cy="117" r="5"/>

          <g filter="url(#device-shadow)">
            <rect class="monitor-frame" x="67" y="42" width="169" height="112" rx="9"/>
            <rect x="75" y="50" width="153" height="96" rx="4" fill="url(#screen-surface)"/>
            <path class="cloud-mark" d="M133 99c-10 0-18-7-18-16 0-8 6-15 15-16 4-11 14-19 27-19 15 0 27 10 29 24 9 1 16 8 16 17 0 10-9 18-20 18h-49c-11 0-20-8-20-18 0-9 8-17 20-17"/>
            <path class="cloud-arrow" d="M159 79v23m0-23-9 9m9-9 9 9"/>
            <path class="monitor-neck" d="M139 154v24m26-24v24"/>
            <path class="monitor-base" d="M119 183h66"/>
          </g>

          <g class="phone" filter="url(#device-shadow)">
            <rect x="45" y="94" width="58" height="103" rx="12" fill="url(#phone-surface)"/>
            <rect class="phone-frame" x="45" y="94" width="58" height="103" rx="12"/>
            <path class="phone-speaker" d="M68 103h12"/>
            <circle class="phone-home" cx="74" cy="187" r="3"/>
            <path class="phone-lock" d="M67 142v-7a7 7 0 0 1 14 0v7m-17 0h20v17H64z"/>
          </g>
        </svg>
      </div>

      <h1 id="mobile-unavailable-message">
        Mobile access is not available yet.<br>
        Please sign in on a computer.
      </h1>
    </section>

    <div class="home-indicator" aria-hidden="true"></div>
  </main>
</template>

<script>
export default {
  name: 'MobileUnavailable',
  mounted () {
    document.title = 'Viwoods Cloud'
  }
}
</script>

<style>
html,
body,
#app {
  width: 100%;
  min-width: 320px;
  min-height: 100%;
  margin: 0;
}

body {
  background: #f4f6f1;
}
</style>

<style scoped>
.mobile-unavailable {
  position: relative;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  padding: max(28px, env(safe-area-inset-top)) 24px max(18px, env(safe-area-inset-bottom));
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: #173c2d;
  background:
    radial-gradient(circle at 50% 45%, rgba(255, 255, 255, .94) 0, rgba(255, 255, 255, .52) 30%, rgba(244, 246, 241, 0) 63%),
    linear-gradient(160deg, #f8f9f6 0%, #f0f3ed 100%);
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  isolation: isolate;
}

.brand {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
}

.brand img {
  display: block;
  width: 150px;
  height: auto;
}

.message-panel {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 390px;
  margin: auto;
  padding: 28px 0 62px;
  box-sizing: border-box;
  text-align: center;
}

.device-illustration {
  width: min(84vw, 300px);
  margin: 0 auto 38px;
}

.device-illustration svg {
  display: block;
  width: 100%;
  height: auto;
  overflow: visible;
}

.orbit {
  fill: none;
  stroke: #b9c5b6;
  stroke-linecap: round;
  stroke-width: 1.5;
  stroke-dasharray: 4 8;
}

.orbit-back {
  opacity: .68;
}

.orbit-front {
  opacity: .46;
}

.orbit-dot {
  fill: #6d8679;
}

.orbit-dot-left {
  animation: float-dot 4.8s ease-in-out infinite;
}

.orbit-dot-right {
  animation: float-dot 4.8s 1.2s ease-in-out infinite reverse;
}

.monitor-frame {
  fill: #1c4132;
}

.cloud-mark {
  fill: #d7e2d2;
}

.cloud-arrow,
.monitor-neck,
.monitor-base,
.phone-speaker,
.phone-lock {
  fill: none;
  stroke: #1c4132;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 4;
}

.monitor-neck,
.monitor-base {
  stroke-width: 7;
}

.phone {
  animation: phone-breathe 5s ease-in-out infinite;
  transform-origin: 74px 146px;
}

.phone-frame {
  fill: none;
  stroke: #1c4132;
  stroke-width: 4;
}

.phone-speaker {
  stroke-width: 2.5;
}

.phone-home {
  fill: #88a090;
}

.phone-lock {
  stroke-width: 3;
}

h1 {
  margin: 0;
  color: #193e30;
  font-size: clamp(25px, 7vw, 31px);
  font-weight: 600;
  letter-spacing: -.035em;
  line-height: 1.36;
  text-wrap: balance;
}

.ambient {
  position: absolute;
  z-index: 0;
  border-radius: 50%;
  filter: blur(2px);
  pointer-events: none;
}

.ambient-top {
  top: -145px;
  right: -150px;
  width: 330px;
  height: 330px;
  background: rgba(203, 216, 197, .52);
}

.ambient-bottom {
  bottom: -190px;
  left: -175px;
  width: 380px;
  height: 380px;
  background: rgba(216, 225, 210, .62);
}

.home-indicator {
  position: relative;
  z-index: 2;
  width: 112px;
  height: 4px;
  margin: 0 auto;
  border-radius: 999px;
  background: rgba(25, 62, 48, .22);
}

@keyframes float-dot {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-7px);
  }
}

@keyframes phone-breathe {
  0%, 100% {
    transform: translateY(0) rotate(0);
  }
  50% {
    transform: translateY(-4px) rotate(-1deg);
  }
}

@media (max-height: 660px) {
  .message-panel {
    padding: 12px 0 24px;
  }

  .device-illustration {
    width: min(68vw, 235px);
    margin-bottom: 22px;
  }

  h1 {
    font-size: 23px;
  }
}

@media (orientation: landscape) and (max-height: 520px) {
  .mobile-unavailable {
    padding-right: max(32px, env(safe-area-inset-right));
    padding-left: max(32px, env(safe-area-inset-left));
  }

  .brand {
    justify-content: flex-start;
  }

  .message-panel {
    max-width: 720px;
    padding: 12px 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 42px;
    text-align: left;
  }

  .device-illustration {
    width: min(43vw, 235px);
    margin: 0;
    flex: 0 0 auto;
  }

  h1 {
    max-width: 350px;
    font-size: 23px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .orbit-dot,
  .phone {
    animation: none;
  }
}
</style>
